import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { SideNavComponent } from './side-nav.component';

@NgModule({
  imports: [
    CommonModule,
    MatListModule,
    MatTooltipModule,
    FlexLayoutModule,
    FlexModule,
    RouterModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule
  ],
  declarations: [SideNavComponent],
  exports: [SideNavComponent]
})
export class SideNavModule {}
